<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="titlepage" id="bk">
<h1 class="bk"><a class="page" id="pii"></a><a class="page" id="piii"></a>Going All City</h1>
<h1 class="bk1">Struggle and Survival in LA’s Graffiti Subculture</h1>
<p class="bkau">Stefano Bloch</p>
<p class="bkpub">The University of Chicago Press    Chicago and London</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-bloch-0003.vue?f27b9bd6